import React, { useState, useEffect } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { t } from "@lingui/macro";

const CheckoutForm = ({ paymentData, onPaymentSuccess, onPaymentError }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);

  useEffect(() => {
    if (!stripe) return;

    const { amount, currency, country, label } = paymentData;

    const pr = stripe.paymentRequest({
      country: country,
      currency: currency,
      total: {
        label: label,
        amount: amount * 100,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    pr.canMakePayment().then((result) => {
      if (result) {
        setPaymentRequest(pr);
      }
    });

    return () => {
      pr.off("paymentmethod");
    };
  }, [stripe, paymentData]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.origin },
      redirect: "if_required",
    });

    if (error) {
      onPaymentError(error.message);
      setLoading(false);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      onPaymentSuccess(paymentIntent.id);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      {paymentRequest && (
        <PaymentRequestButtonElement options={{ paymentRequest }} />
      )}

      <div className="form-actions">
        <button
          className="add-new-btn"
          type="submit"
          disabled={!stripe || loading}
        >
          {loading ? t`Processing...` : t`Pay Now`}
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;
